import { useMutation, useQuery } from '@apollo/client/react';
import {
  STAFF_DUNNING_EMAIL_RECIPIENTS,
  STAFF_SET_DUNNING_EMAIL_EXCLUSION,
} from '@staff-app/graphql-client';

// Billing Console → "Dunning emails": per-account, per-address dunning email exclusions.

export type DunningEmailRecipient = {
  email: string;
  /** Why this address gets dunning emails — e.g. `Billing email`, `Owner`, `Admin`. */
  sources: string[];
  excluded: boolean;
  comment?: string | null;
  excludedBy?: string | null;
  excludedAt?: string | null;
};

export type DunningEmailRecipients = {
  accountId: string;
  recipients: DunningEmailRecipient[];
};

export type SetDunningEmailExclusionVars = {
  accountId: string;
  email: string;
  excluded: boolean;
  comment?: string | null;
};

/** Fetches only while `accountId` is set (the dialog passes null when closed). */
export function useDunningEmailRecipients(accountId: string | null) {
  return useQuery<{ dunningEmailRecipients: DunningEmailRecipients }, { accountId: string }>(
    STAFF_DUNNING_EMAIL_RECIPIENTS,
    {
      variables: { accountId: accountId ?? '' },
      skip: !accountId,
      fetchPolicy: 'network-only',
    },
  );
}

export function useSetDunningEmailExclusion() {
  return useMutation<
    { setDunningEmailExclusion: DunningEmailRecipients },
    SetDunningEmailExclusionVars
  >(STAFF_SET_DUNNING_EMAIL_EXCLUSION);
}
